function windowHeight() {
  var windowHeight = window.innerHeight;
  return windowHeight;
}
function headerHeight() {
  if (document.body.contains(document.querySelector('[data-site-header]'))) {
    const headerHeight =
      document.querySelector('[data-site-header]').offsetHeight;
    //console.log(headerHeight);
    return headerHeight;
  } else {
    return;
  }
}

//console.log('header-height',headerHeight());
document.documentElement.style.setProperty(
  '--window-height',
  windowHeight() + 'px'
);
document.documentElement.style.setProperty(
  '--header-height',
  headerHeight() + 'px'
);

addEventListener(
  'resize',
  debounce(() => {
    document.documentElement.style.setProperty(
      '--window-height',
      windowHeight() + 'px'
    );
    document.documentElement.style.setProperty(
      '--header-height',
      headerHeight() + 'px'
    );
  }, 100)
);

/************ STICKY HEADER ***************/

const siteHeader = document.querySelector('[data-site-header]');
if (siteHeader) {
  function fixHeader() {
    const stickyOffset = siteHeader.offsetHeight + 200;
    const scroll = window.scrollY;
    //console.log(scroll);
    if (scroll > stickyOffset) {
      if (!siteHeader.classList.contains('scrolling', 'fixed')) {
        siteHeader.classList.add('scrolling');
        siteHeader.classList.add('fixed');
      }
    } else {
      if (siteHeader.classList.contains('scrolling', 'fixed')) {
        siteHeader.classList.remove('scrolling');
        siteHeader.classList.remove('fixed');
      }
    }
  }

  window.addEventListener(
    'touchmove',
    debounce(function () {
      fixHeader();
    }, 50)
  );

  window.addEventListener(
    'scroll',
    debounce(function () {
      fixHeader();
    }, 50)
  );

  window.addEventListener(
    'resize',
    debounce(function () {
      fixHeader();
    }, 50)
  );

  window.addEventListener('load', (event) => {
    fixHeader();
  });
}

/***************** SLIDE TOGGLES *******************/

document.querySelectorAll('[data-toggle-target]').forEach((toggle) => {
  toggle.addEventListener('click', (e) => {
    e.preventDefault();
    const target = toggle.dataset.toggleTarget;
    //console.log(target,"TARGET");
    const toggleContainer = document.querySelectorAll(
      `[data-tab-content="${target}"]`
    );
    // console.log(toggleContainer);
    const toggleClass = (toggle, className) =>
      toggle.classList.toggle(className);
    toggleClass(toggle, 'active');

    toggleContainer.forEach((group) => {
      if (!group.classList.contains('active')) {
        group.classList.add('active');

        group.style.height = 'auto';
        const height = group.clientHeight + 'px';
        group.style.height = '0px';

        setTimeout(function () {
          group.style.height = height;
        }, 0);
        group.addEventListener(
          'transitionend',
          function () {
            group.style.height = 'auto';
          },
          {
            once: true,
          }
        );
      } else {
        group.style.height = 'auto';
        const height = group.clientHeight + 'px';
        console.log(height, 'height');
        group.style.height = height;
        setTimeout(function () {
          group.style.height = '0px';
        }, 0);

        group.addEventListener(
          'transitionend',
          function () {
            group.classList.remove('active');
          },
          {
            once: true,
          }
        );
      }
    });
  });
});

/*************** TAB TOGGLES ***********/
document.querySelectorAll('[data-tab-target]').forEach((tab) => {
  tab.addEventListener('click', (e) => {
    e.preventDefault();
    const target = tab.dataset.tabTarget;
    const tabGroup = tab.dataset.tabGroup;
    console.log(target, 'TARGET');
    console.log(tabGroup, 'TAB GROUP');
    const tabGroups = document.querySelectorAll(
      `[data-tab-group="${tabGroup}"]`
    );
    tabGroups.forEach((group) => {
      group.classList.remove('active');
    });
    tab.classList.add('active');
    document
      .querySelectorAll(
        `[data-tab-content="${target}"][data-tab-group="${tabGroup}"]`
      )
      .forEach((group) => {
        group.classList.add('active');
      });
  });
});

// MODAL TOGGLING
document.querySelectorAll('[data-modal-target]').forEach((btnOpen) => {
  btnOpen.onclick = function (event) {
    const target = btnOpen.dataset.modalTarget;
    const modalContent = document.querySelector(
      `[data-modal-content="${target}"]`
    );
    const closeModal = modalContent.querySelectorAll('[data-close]');
    const modalSlider = modalContent.querySelector('.bd-slider');

    console.log(modalSlider);
    event.preventDefault();
    console.log('open modal');
    modalContent.classList.add('active');

    document.querySelector('body').classList.add('overflow-hidden');
    closeModal.forEach((exit) => {
      exit.onclick = function () {
        console.log('close modal');
        modalContent.classList.remove('active');
        document.querySelector('body').classList.remove('overflow-hidden');
      };
    });
    window.onclick = function (event) {
      if (event.target == modalContent) {
        console.log('close modal');
        modalContent.classList.remove('active');
        document.querySelector('body').classList.remove('overflow-hidden');
      }
    };
    window.addEventListener('keyup', function (e) {
      if (e.code === 'Escape') {
        modalContent.classList.remove('active');
        document.querySelector('body').classList.remove('overflow-hidden');
      }
    });

    if (modalSlider) {
      const slider = new Flickity(modalSlider);
      console.log('resize slider');
      slider.resize();
    }
  };
});

/************ Smooth Scroll  ****************/

document
  .querySelectorAll(
    'a[href*="#"]:not([href="#"], .no-scroll, [data-toggle-target])'
  )
  .forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      console.log('scroll to ', e);
      const offset = headerHeight() * -2;
      if (
        location.pathname.replace(/^\//, '') ==
          this.pathname.replace(/^\//, '') &&
        location.hostname == this.hostname
      ) {
        let target = anchor.hash;
        target = target.length
          ? target
          : document.querySelector(`[name="${this.hash.slice(1)}"]`);

        if (target.length) {
          const element = document.getElementById(target.replace('#', ''));
          console.log('element', element);
          window.scrollTo({
            top: getOffsetTop(element) + offset,
            left: 0,
            behavior: 'smooth',
          });
        }
      }
    });
  });

  function getOffsetTop(element) {
    return element ? element.offsetTop + getOffsetTop(element.offsetParent) : 0;
  }
  
  
// RANGE SLIDERS

function createRangeSliders() {
  let rangeMin = 0;
  document.querySelectorAll('[data-range-container]').forEach((ranger) => {
    //console.log(ranger, 'ranger');
    const rangeInput = ranger.querySelectorAll('[data-range-slider] input');
    const rangePrice = ranger.querySelectorAll('[data-range-prices] input');
    const range = ranger.querySelector('[data-range-selected]');
    // console.log('range', range);
    function getPosition(rangeInput, rangePrice, range) {
      let minRange = parseInt(rangeInput[0].value);
      let maxRange = parseInt(rangeInput[1].value);
      if (maxRange - minRange < rangeMin) {
        if (e.target.className === 'min') {
          rangeInput[0].value = maxRange - rangeMin;
        } else {
          rangeInput[1].value = minRange + rangeMin;
        }
      } else {
        rangePrice[0].value = minRange;
        rangePrice[1].value = maxRange;
        range.style.left = (minRange / rangeInput[0].max) * 100 + '%';
        range.style.right = 100 - (maxRange / rangeInput[1].max) * 100 + '%';
      }
    }
    rangeInput.forEach((input) => {
      getPosition(rangeInput, rangePrice, range);
      input.addEventListener('input', () => {
        getPosition(rangeInput, rangePrice, range);
      });
    });

    rangePrice.forEach((input) => {
      input.addEventListener('input', (e) => {
        let minPrice = rangePrice[0].value;
        let maxPrice = rangePrice[1].value;
        if (maxPrice - minPrice >= rangeMin && maxPrice <= rangeInput[1].max) {
          if (e.target.className === 'min') {
            rangeInput[0].value = minPrice;
            range.style.left = (minPrice / rangeInput[0].max) * 100 + '%';
          } else {
            rangeInput[1].value = maxPrice;
            range.style.right =
              100 - (maxPrice / rangeInput[1].max) * 100 + '%';
          }
        }
      });
    });
  });
}



document.querySelector('body').classList.remove('loading');